import inviteEmailModalTemplate from '../../views/modals/invite-email-modal.tpl.html';
import InviteEmailModalController from '../../controllers/modals/invite-email-modal-controller';

class InviteUserWorkflow {
    constructor($injector) {
        this.injector = $injector;
        this.state = this.injector.get('$state');
        this.modal = this.injector.get('$uibModal');
        this.translate = this.injector.get('$translate');

        this.key = 'invite-user';
        this.title = this.translate.instant('user.workflows.invite.name');
        this.level = 'highlight';
        this.icon = 'plus-circle';
    }

    action(payload, store) {
        this.modal.open({
            templateUrl: inviteEmailModalTemplate,
            controller: InviteEmailModalController,
            size: 'md',
            controllerAs: 'vm'
        });
    }

}

angular
    .module('festzelt-os.modules.users')
    .factory('inviteUser', [
        '$injector',
        ($injector) => new InviteUserWorkflow($injector)
    ]);



// WEBPACK FOOTER //
// ./src/app/modules/users/workflows/list/invite-user.js